// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1URro","label":"CategoryService_label__1Mfvn","location":"CategoryService_location__Mohrf"};